var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"col-6 btn-redirect btn-lg btn",attrs:{"href":("/" + _vm.user_role + "/" + _vm.session)}},[_c('h4',{staticClass:"btn-redirect-text"},[_vm._v("Gerar Novo Cupom")])])}
var staticRenderFns = []

export { render, staticRenderFns }